import React from "react";
const SearchIcon = () => {
  return (
    <svg width="18" height="18" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M14 13.3L9.70001 9.00001C11.6 6.70001 11.3 3.20001 9.00001 1.30001C6.70001 -0.599986 3.20001 -0.299986 1.30001 2.00001C-0.599986 4.30001 -0.299986 7.80001 2.00001 9.70001C4.00001 11.4 7.00001 11.4 9.00001 9.70001L13.3 14L14 13.3ZM1.00001 5.50001C1.00001 3.00001 3.00001 1.00001 5.50001 1.00001C8.00001 1.00001 10 3.00001 10 5.50001C10 8.00001 8.00001 10 5.50001 10C3.00001 10 1.00001 8.00001 1.00001 5.50001Z" fill="black"/>
    </svg>
  );
};

export default SearchIcon